import { render, staticRenderFns } from "./MobileCurrentTenantsStat.vue?vue&type=template&id=54568313&"
import script from "./MobileCurrentTenantsStat.vue?vue&type=script&lang=js&"
export * from "./MobileCurrentTenantsStat.vue?vue&type=script&lang=js&"
import style0 from "./MobileCurrentTenantsStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports